import React, { useContext } from "react";
import styles from "./ResourceMonitor.module.scss";
import { NotFoundIcon } from "../../../modules/default-svg";
import TaskCard from "./Calandars/TaskCard";
import { ResourcePlannerContext } from "./ResourcePlannerContext";
import Spin from "../../../components/controls/spinner/Spin";
import NotFoundLayout from "../../../components/controls/NotFound/NotFound";

const AssignedTasksCard = () => {
  const { taskLoader, tasks } = useContext(ResourcePlannerContext);
  
  return (
    <div className={styles.TaskCardContainer}>
      <div className={styles.cardSubHeader}>
        <h5>Assigned Tasks</h5>
      </div>
      <div className={styles.CalendarModalScroll}>
        {taskLoader ? (
          <div className={styles.spinnerContainer}>
            <Spin />
          </div>
        ) : (
          <div
            className={`row ${styles.cardBody}`}
            style={{ "--bs-gutter-x": "12px", "--bs-gutter-y": "16px" }}
          >
            {Array.isArray(tasks?.tasks) && tasks.tasks.length > 0 ? (
              tasks?.tasks.map((item) => (
                <TaskCard key={item.id} item={item} assignShift={false} />
              ))
            ) : (
              <NotFoundLayout
                icon={<NotFoundIcon />}
                heading="No data currently available!"
                para=""
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default AssignedTasksCard;
